<template>
  <div class="page">
    <Header></Header>
    <div class="title">
      <div class="title-text">应聘记录</div><div class="title-ext" @click="gotoResume">我的简历</div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          :finished="finished"
          :finished-text="!loading && (!list || list.length==0)?'':'没有更多了'"
          @load="onLoad"
      >
        <div class="box" v-for="(item,i) in list" :key="i">
          <div class="box-title">
            <div class="box-title-text">
              {{item.positionName}}
            </div>
            <van-tag v-if="item.positionStatusName && item.positionStatusName=='招聘中'" color="#e9f9f0" text-color="#27C36F">{{item.positionStatusName}}</van-tag>
            <van-tag v-if="item.positionStatusName && item.positionStatusName!='招聘中'" color="#F5F7FA" text-color="#9499B0">{{item.positionStatusName}}</van-tag>
          </div>
          <div class="box-content">
            <div class="box-content-v">
              <div class="box-item">
                <div class="box-item-text">投递时间：</div>
                <div class="box-item-value">{{item.shwoDate}}</div>
              </div>
              <div class="box-item">
                <div class="box-item-text">当前进度：</div>
                <div class="box-item-value">{{item.state}}</div>
              </div>
            </div>
<!--            <div v-if="item.id!=0" class="box-item-ext" @click="delivery(item)">-->
<!--              重新投递-->
<!--            </div>-->
          </div>
          <van-cell title="查看进度详情" is-link @click="gotoResumeProcess(item)" />
        </div>
      </van-list>
      <NoData v-if="!loading && (!list || list.length==0)" message="暂无应聘记录" btntext="查看更多工作机会" :callback="gotoPostionList"></NoData>
      <SafeBottom></SafeBottom>
    </van-pull-refresh>
    <Footer></Footer>
    <Dialog :visible="showDeliverConfirm" :call-back="deliveryConfirm">
      <div>
        以最新简历重新投递吗？
      </div>
<!--      <div style="color: #9499B0;text-align: left;margin-top: 16px;">-->
<!--        <span style="color:#F25058;margin-right: 4px;height: 14px;">*</span>-->
<!--        个人规划及发展方向-->
<!--      </div>-->
<!--      <van-field style="margin-top: 8px;margin-bottom: 4px;" v-model="resumeDetail.expectedJob" placeholder="请选择个人规划及发展方向" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event)" />-->
    </Dialog>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
          title=""
          show-toolbar
          :columns="pickerOptions"
          value-key="dict_name"
          @cancel="showPicker = false"
          @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Toast,
  Image as VanImage,
  List,
  PullRefresh,
  Popup,
  Picker,
  Icon,
  Cell,
  Tag,
} from 'vant';
import 'vant/lib/index.css';
import Request from "../utils/Request";
import Urls from "../utils/Urls";
import wx from 'weixin-js-sdk';
import Utils from "../utils/Utils";
import Header from "./Header1";
import Footer from "./Footer";
import NoData from "./NoData";
import SafeBottom from "./SafeBottom";
import Dialog from "./Dialog/Dialog1";
Vue.use(VanImage);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Cell);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Icon);
Vue.use(Tag);

export default {
  name: "DeliveryList",
  components:{
    SafeBottom,
    NoData,
    Header,
    Footer,
    Dialog
  },
  data(){
    return {
      app:"",
      pageCount:1,
      currentPage:0,
      pageSize:10,
      refreshing:false,
      loading:false,
      finished:false,
      search: "",
      list: [],
      pickerOptions:[],
      showPicker:false,
      showDeliverConfirm:false,
      currentItem:{},
      onlineUri:'',
      resumePath:'',
      resumeDetail:{
        Name:"",
        Mobile:"",
        Email:"",
        Sex:"",
        EducationInfo:[{
          School:"",
          Speciality:"",
          StartDate:"",
          EndDate:"",
          Education:""
        }],
        ExperienceInfo:[{
          Company: "",
          Title: "",
          StartDate: "",
          EndDate: "",
          Summary: ""
        }],
        ProjectInfo:[],
        certificateInfo:[],
        LanguagesSkills:[],
        worksInfo:[],
        internshipInfo:[],
        contestInfo:[],
      },
    };
  },
  mounted: function()
  {
    this.app=Utils.getApp();
    this.getUserInfo();
  },
  methods: {
    getDeliveryList(){
      let that = this;
      that.loading=true;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getDeliveryList, {
        schoolRecruit:1,
        currentPage:that.currentPage,
        pageSize:that.pageSize,
        search: that.search,
      }).then(res=>{
        that.loading=false;
        that.refreshing=false;
        Toast.clear();
        if (res) {
          let list=res.list || [];
          that.list =that.currentPage==1?list:that.list.concat(list);
          if(res.count>that.pageSize)
          {
            if(res.count%that.pageSize==0)
            {
              this.pageCount=res.count/that.pageSize;
            }
            else
            {
              this.pageCount=res.count/that.pageSize+1;
            }
          }
          if(that.currentPage>=that.pageCount)
          {
            that.finished=true;
          }
        }
      });
    },
    getUserInfo(){
      let that=this;
      this.loading=true;
      Request.request(Urls.getUserInfo).then((data)=>{
        this.loading=false;
        if(data)
        {
          that.fileIcon=Utils.getFileIcon(data.resumePath);
          that.onlineUri=data.onlineUri;
          that.resumePath=data.resumePath;
          if(data.resumeDetail) {
            let resumeDetail=JSON.parse(data.resumeDetail);
            if(resumeDetail.educationInfo && resumeDetail.educationInfo instanceof Array) {
              delete resumeDetail.educationInfo;
            }
            if(resumeDetail.experienceInfo && resumeDetail.experienceInfo instanceof Array) {
              delete resumeDetail.experienceInfo;
            }
            if(resumeDetail.projectInfo && resumeDetail.projectInfo instanceof Array) {
              delete resumeDetail.projectInfo;
            }
            if(resumeDetail.trainingInfo && resumeDetail.trainingInfo instanceof Array) {
              delete resumeDetail.trainingInfo;
            }
            that.resumeDetail ={...that.resumeDetail,...resumeDetail};
            if(that.resumeDetail.Email)
            {
              that.sendEmail=that.resumeDetail.Email;
            }
            if(!(that.resumeDetail.EducationInfo && that.resumeDetail.EducationInfo.length>0))
            {
              that.resumeDetail.EducationInfo=[{
                School:"",
                Speciality:"",
                StartDate:"",
                EndDate:"",
                Education:""
              }];
            }
            if(!(that.resumeDetail.ExperienceInfo && that.resumeDetail.ExperienceInfo.length>0))
            {
              that.resumeDetail.ExperienceInfo=that.postion.targetId=='1004'?[]:[{
                Company: "",
                Title: "",
                StartDate: "",
                EndDate: "",
                Summary: ""
              }];
            }
            if(!(that.resumeDetail.ProjectInfo))
            {
              that.resumeDetail.ProjectInfo=[];
            }
            if(!(that.resumeDetail.certificateInfo))
            {
              that.resumeDetail.certificateInfo=[];
            }
            if(!(that.resumeDetail.LanguagesSkills))
            {
              that.resumeDetail.LanguagesSkills=[];
            }
            else
            {
              that.resumeDetail.LanguagesSkills.forEach(l=>{
                l.langtype=l.Languages.indexOf('英语')!=-1?'英语':'其他';
              });
            }
            if(!(that.resumeDetail.worksInfo))
            {
              that.resumeDetail.worksInfo=[];
            }
            if(!(that.resumeDetail.internshipInfo))
            {
              that.resumeDetail.internshipInfo=[];
            }
            if(!(that.resumeDetail.contestInfo))
            {
              that.resumeDetail.contestInfo=[];
            }
          }
        }
      });
    },
    delivery1(item)
    {
        console.log(item)
        let that = this;
        if(item.targetId!='1004' && (!this.resumeDetail.ExperienceInfo || this.resumeDetail.ExperienceInfo.length==0))
        {
          Toast('投递社招职位，请完善工作经历后在投递');
          return;
        }
        this.$Dialog.confirm({
          title: '提示',
          message: '以最新简历重新投递吗？',
        })
        .then(() => {

            Toast.loading({
              duration: 0,
              forbidClick: true,
            });
            Request.requestJson(Urls.updateDelivery, {
              id:item.id,
              edit:false,
            }).then(res=>{
              Toast.clear();
              if (res) {
                Toast('投递成功');
              }
            });

        })
        .catch(() => {
          // on cancel
        });
    },
    delivery(item)
    {
      console.log(item)
      let that = this;
      this.currentItem=item;
      if(item.targetId=='1004')
      {
        let expectedjobList=[];
        if(item.tags)
        {
          item.tags.split('/').forEach(tag=>{
            expectedjobList.push({dict_value:tag,dict_name:tag});
          });
        }
        this.pickerOptions=expectedjobList;
        console.log(this.pickerOptions)
        this.showDeliverConfirm=true;
      }
      else
      {
        this.$Dialog.confirm({
          title: '提示',
          message: '以最新简历重新投递吗？',
        })
        .then(() => {
          that.upResume(item);
        })
        .catch(() => {
          // on cancel
        });
      }
    },
    showPopup(e) {
      this.showPicker = true;
    },
    onConfirm(value)
    {
      this.showPicker = false;
      console.log(value)
      this.resumeDetail.expectedJob=value.dict_name;
    },
    upResume(item){
        let that = this;
        if(item.targetId=='1004')
        {
          // if(!this.resumeDetail.expectedJob)
          // {
          //   Toast('请选择个人规划及发展方向');
          //   return;
          // }
        }
        else
        {
          if(!this.resumeDetail.ExperienceInfo || this.resumeDetail.ExperienceInfo.length==0)
          {
            Toast('投递社招职位，请完善工作经历后在投递');
            return;
          }
        }
        Toast.loading({
          duration: 0,
          forbidClick: true,
        });
        Request.requestJson(Urls.updateDelivery, {
          id:item.id,
          resumeDetail:JSON.stringify(this.resumeDetail),
          edit:true,
        }).then(res=>{
          Toast.clear();
          if (res) {
            Toast('投递成功');
          }
        });
    },
    deliveryConfirm(action){
      if(action)
      {
        this.upResume(this.currentItem);
      }
    },
    onLoad()
    {
      if(this.finished || this.refreshing)
      {
        return false;
      }
      this.currentPage+=1;
      console.log(this.currentPage)
      this.getDeliveryList();
    },
    onRefresh()
    {
      this.finished=false;
      this.currentPage=1;
      this.getDeliveryList();
    },
    gotoPostionList()
    {
      if(this.app=='WeiXinMini')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.switchTab({
          url: '/pages/m/m',
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'/positionlist'});
      }
    },
    gotoResume(){
      if(this.app=='WeiXinMini' && this.$route.query.minipage=='m')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateTo({
          url: '/pages/m/child?url='+encodeURIComponent('/resume'),
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'/resume'});
      }
    },
    gotoResumeProcess(item)
    {
      if(this.app=='WeiXinMini' && this.$route.query.minipage=='m')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateTo({
          url: '/pages/m/child?url=process&param='+encodeURIComponent('positionId='+item.position_id+'&id='+item.resume_id),
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'/process',query:{positionId:item.position_id,id:item.id}});
      }
    },
  }
}
</script>

<style scoped>
.page{
  background-color: #F5F7FA;
  /*height: 100%;*/
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
  /*justify-content: center;*/
}
.title{
  margin: 16px 20px;
  display: flex;
  align-items: center;
}
.title-text{
  flex: 1;
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #20253F;
  line-height: 22px;
  font-weight: 500;
}
.title-ext{
  height: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #3A5FFF;
  text-align: right;
  line-height: 16px;
  font-weight: 400;
}
.van-pull-refresh {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.box{
  margin: 0 20px 10px;
  padding: 16px;
  background-color: #FFFFFF;
  border-radius: 6px;
}
.box-title{
  display: flex;
  align-items: center;
}
.box-title-text{
  flex: 1;
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #20253F;
  line-height: 22px;
  font-weight: 500;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.van-tag
{
  padding: 3px 4px;
  white-space: nowrap;
}

.box-content
{
  padding: 12px 0;
  border-bottom:1px solid #E6EBF5;
  display: flex;
  align-items: center;
}
.box-content-v
{
  flex: 1;
}
.box-item{
  display: flex;
  align-items: center;
}
.box-item+.box-item
{
  margin-top: 6px;
}
.box-item-ext{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #3A5FFF;
  line-height: 18px;
  font-weight: 400;
}
.box-item-text{
  height: 16px;
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #9499B0;
  line-height: 16px;
  font-weight: 400;
}
.box-item-value{
  flex: 1;
  height: 16px;
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #20253F;
  line-height: 16px;
  font-weight: 400;
}
.van-cell {
  width: auto;
  margin-top: 12px;
  padding: 0;
  display: flex;
  align-items: center;
}
.van-cell__title
{
  height: 12px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #3A5FFF;
  line-height: 12px;
  font-weight: 400;
}
.van-cell__right-icon{
  font-size: 12px;
  color: #9499B0;
 }

.van-picker>>> .van-picker__confirm {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #3A5FFF;
}
.van-picker>>> .van-picker__cancel {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #20253F;
}

.van-picker>>> .van-picker-column__item{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #CCCFD8;
}

.van-picker>>> .van-picker-column__item--selected{
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #3A5FFF;
}
</style>